export const referralKeys = {
  all: ["referral"] as const,
  code: () => [...referralKeys.all, "code"] as const,
  pendingBonus: () => [...referralKeys.all, "pendingBonus"] as const,
  stats: () => [...referralKeys.all, "stats"] as const,
  history: (page: number, take: number) => [...referralKeys.all, "history", page, take] as const,
};
